module.exports = __webpack_public_path__ + "static/media/aygun5.04bf2ea4.jpg";